<template>
  <div>
    <toast ref="toast"></toast>
    <router-view></router-view>
  </div>
</template>

<script>
import axios from "axios";
import { setErrorMessageCallback, handleError } from "@/lib/errorHandling";
import Toast from "@/components/Toast.vue";
export default {
  mounted() {
    setErrorMessageCallback((message, type = "info") => {
      this.$refs.toast.show(message, type);
    });
    this.checkToken();
  },
  methods: {
    async checkToken() {
      const url = `${process.env.VUE_APP_BACKEND_BASE_URL}users/verify-token`;
      console.log({ url });
      const token = localStorage.getItem("token");
      if (!token) return;
      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (e) {
        handleError(e);
      }
    },
  },
  components: {
    Toast,
  },
};
</script>
<style lang="scss">
@font-face {
  font-family: "TheMix";
  src: url("/fonts/TheMixC5s-5_Plain.woff2");
  font-display: swap;
  font-style: normal;
  font-weight: 400;
}

:root {
  --primary-color: #ec7404;
  --primary-color-050: #feeee3;
  --primary-color-100: #fde5d0;
  --primary-color-200: #fbddb9;
  --primary-color-500: var(--primary-color);
  --gray-050: #f1f1f1;
  --gray-100: #efedef;
  --gray-400: #706e71;
  --gray-500: #39373a;
  --error-100: #ffedee;
  --error-300: #cc8083;
  --error-500: #d7282f;
  --white: #fff;
}

html {
  box-sizing: border-box;
  font-size: 16px;
  font-family: "TheMix", Arial, Helvetica, sans-serif;
  background-color: var(--gray-500);
  overflow: hidden;

  @media print {
    background-color: #fff;
  }
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p,
ol,
ul {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

ol,
ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

h1 {
  font-size: 3rem;
  margin: 0 0 1rem 0;
}

p {
  font-size: 2rem;
  margin: 0 0 2rem 0;
}

hr {
  margin: 4rem 0;
  background: none;
  border-top: none;
  border-bottom: solid 2px rgba(0, 0, 0, 0.1);
}

input:not([type="submit"]):not([type="radio"]):not([type="checkbox"]),
textarea,
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  padding: 0.5rem 1rem 0.5rem 1rem;
  height: rem-calc(82);
  transition: border-color 0.15s ease;
  border: solid 3px var(--gray-500);
  background-color: var(--primary-color-050);
  color: var(--gray-500);
  font-size: 2.5rem;
  line-height: 1.5;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 3px rgba(black, 0.1), 0px 1px 2px rgba(black, 0.06);
  width: 100%;

  &:disabled {
    opacity: 0.4;
  }

  &::placeholder {
    color: var(--gray-400);
  }

  &:hover {
    outline: none;
  }

  &:focus,
  &:active {
    outline: none;
    box-shadow: none !important;
  }

  &.s_error {
    background-color: var(--error-100);
    border-color: var(--error-500);

    &::placeholder {
      color: var(--error-300);
    }
  }
}

button {
  border: none;
  background: none;
  cursor: pointer;
  background: var(--white);
  font-size: 2rem;
  border-radius: 0.5rem;
  padding: 2rem 3rem;
  line-height: 1;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
}

table {
  tr {
  }

  td {
    font-size: 2rem;
    padding: 0.2rem 2rem 0.2rem 0;
  }
}
</style>
